import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

type RequireAuthProps = {
  children: React.ReactNode;
};

function LoginChecker({ children }: RequireAuthProps) {
  const location = useLocation();
  
  // Check if this is a password reset or forgot password page
  const isPasswordResetPage = location.pathname === '/reset-password';
  const isForgotPasswordPage = location.pathname === '/forgot-password';
  const shouldSkipAuth = isPasswordResetPage || isForgotPasswordPage;

  const [isChecking, setIsChecking] = useState(!shouldSkipAuth);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  // Simple check on component mount
  useEffect(() => {
    // Skip auth check for password reset and forgot password pages
    if (shouldSkipAuth) {
      return;
    }

    const checkAuth = async () => {

      try {
        // Get the base URL from environment
        const baseUrl = import.meta.env.VITE_HEALTHY_EMPIRE_SERVER;

        // Call refresh-access endpoint directly
        await axios.post(
          `${baseUrl}/v1/auth/refresh-access`,
          {},
          {
            withCredentials: true, // Important for cookies
            timeout: 10000, // 10 second timeout
          },
        );

        setShouldRedirect(true);
      } catch (error: unknown) {
        const axiosError = error as {
          response?: { status?: number };
          message?: string;
        };

        // If 401 or any error, stay on login page
        if (axiosError.response?.status === 401) {
        } else {
        }

        setIsChecking(false);
      }
    };

    checkAuth();
  }, [shouldSkipAuth]);

  // Redirect to home if refresh was successful
  if (shouldRedirect) {
    return <Navigate to="/" replace />;
  }

  // Show loading while checking
  if (isChecking) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/90 backdrop-blur-sm">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-b-2 border-primary"></div>
          <p className="text-sm text-muted-foreground">
            جاري التحقق من الهوية...
          </p>
        </div>
      </div>
    );
  }

  // Show login page
  return <>{children}</>;
}

// Export simplified version
export function LoginStop(props: RequireAuthProps) {
  return <LoginChecker {...props} />;
}

export default LoginStop;
